import { Navigate } from "react-router-dom";

// Blocks waitlist_staff (branch-scoped users) from pages reserved for managers.
// Everyone else passes through.
function ManagerGuard({ children }) {
  const userType = localStorage.getItem("userType");
  if (userType === "waitlist_staff") {
    return <Navigate to="/table-management/waitlist" replace />;
  }
  return children;
}

export default ManagerGuard;
